export default "__VITE_ASSET__BtOjKsjJ__"